import { render, staticRenderFns } from "./MedicalRecordTypes.vue?vue&type=template&id=10e71354"
import script from "./MedicalRecordTypes.vue?vue&type=script&lang=js"
export * from "./MedicalRecordTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports